import { dispatchActions } from "./Action";

const initialState = {
  awbStickerDetails: null,
  awbStickerError: null,
  paymentPendingDetails: null,
  paymentPendingError: null,
  printerDetails: null,
  printerError: null,
  cpSuccess: null,
  cpError: null,
  srError: null,
};

export const dispatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case dispatchActions.GENERATE_AWB_STICKER_SUCCESS:
      return {
        ...state,
        awbStickerDetails: action.payload,
        awbStickerError: null,
      };

    case dispatchActions.GENERATE_AWB_STICKER_FAILURE:
      return {
        ...state,
        awbStickerDetails: null,
        awbStickerError: action.payload,
      };

    case dispatchActions.GENERATE_PAYMENT_PENDING_PDF_SUCCESS:
      return {
        ...state,
        paymentPendingDetails: action.payload,
        paymentPendingError: null,
      };

    case dispatchActions.GENERATE_PAYMENT_PENDING_PDF_FAILURE:
      return {
        ...state,
        paymentPendingDetails: null,
        paymentPendingError: action.payload,
      };

    case dispatchActions.PRINT_PDF_SUCCESS:
      return {
        ...state,
        printerDetails: action.payload,
        printerError: null,
      };

    case dispatchActions.PRINT_PDF_FAILURE:
      return {
        ...state,
        printerDetails: null,
        printerError: action.payload,
      };

    case dispatchActions.CALL_CREATE_ORDER_API_SUCCESS:
      return {
        ...state,
        cpError: null,
        cpSuccess: action.payload,
      };

    case dispatchActions.CALL_CREATE_ORDER_API_FAILURE:
      return {
        ...state,
        cpError: action.payload,
        cpSuccess: null,
      };

    case dispatchActions.CALL_SR_CREATE_ORDER_API_SUCCESS:
      return {
        ...state,
        srError: null,
      };

    case dispatchActions.CALL_SR_SERVICEABILITY_API_FAILURE:
      return {
        ...state,
        srError: action.payload,
      };

    default:
      return state;
  }
};
